import { TEMPLATE_TYPE, DEVICE_PREVIEW_IMAGE_URL } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import TemplatePickerCard from './TemplatePickerCard';
import { DeviceFrameDesktop } from 'foundations-components/transitional/components/DeviceFrame';
import { Image } from 'foundations-components/transitional/components/Image';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TemplatePickerPanel = ({
  currentTemplate,
  onChooseTemplateClick
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    children: [/*#__PURE__*/_jsxs(Flex, {
      paddingInlineEnd: "700",
      flexDirection: "column",
      inlineSize: "50%",
      flexGrow: "1",
      flexShrink: "1",
      children: [/*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        children: [/*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "knowledgeContentUI.chooseTemplate.templatePickerPanel.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "knowledgeContentUI.chooseTemplate.templatePickerPanel.tip"
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "start",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          gap: "1100",
          children: [/*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.CONTENT
          }), /*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.TILES
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          marginBlockStart: "700",
          gap: "1100",
          children: [/*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.MINIMAL
          }), /*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.CARDS
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          display: "inline-flex",
          marginBlockStart: "700",
          children: /*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.DEFAULT
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      paddingInlineEnd: "700",
      flexDirection: "column",
      inlineSize: "50%",
      flexGrow: "1",
      flexShrink: "1",
      children: [/*#__PURE__*/_jsx(DeviceFrameDesktop, {
        inlineSize: "85%",
        children: /*#__PURE__*/_jsx(Image, {
          src: DEVICE_PREVIEW_IMAGE_URL[currentTemplate]
        })
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "700",
        as: "div",
        children: [/*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `knowledgeContentUI.chooseTemplate.templates.${currentTemplate}.title`
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `knowledgeContentUI.chooseTemplate.templates.${currentTemplate}.description`
          })
        })]
      })]
    })]
  });
};
export default TemplatePickerPanel;